module.exports = __webpack_public_path__ + "media/images/sp/stores/yokohama/yokohama_sns_02-cbb3080ec673de6678184cb01ecb2bb7.jpg";